// dependancies
import React from "reactn";
import appHook from "../../../hooks/appHook";
import Validate from "./userDetailsRules";

// components
import UserInfoForm from "./user_info/userInfoForm";
import AddressWrapper from "./address/AddressWrapper";
import Button from "../../_common/Button/Button";
import PaymentOptions from "./payment_options/PaymentOptions";
import UserProgress from "./progress/userProgress";

// styled components
import PageTitle from "../../_common/pageTitle/PageTitle.styled";
import SideContainer from "../../_common/containers/SideContainer";
import ContainerBox from "../../_common/containers/ContainerBox";
import FlexStart from "../../_common/containers/FlexStartContainer";
import PageText from "../../_common/pageText/PageText.styled";

const UserDetails = props => {
    const { history } = props;
    const submitForm = () => {
        if (window.collectorsCorner || window.collectorsCornerSubs) {
            history.push("/subscriptions");
        } else if (window.collectorsCornerUser) {
            history.push("/new-user-details");
        } else {
            history.push("/review");
        }
    };
    const {
        handleChange,
        handleKeyup,
        handleBlur,
        handleSubmit,
        values,
        errors
    } = appHook(Validate, submitForm);

    return (
        <div className="grid-container">
            <UserProgress></UserProgress>
            <div className="flex--space-between">
                <SideContainer>
                    <PageTitle className="color--grey-d">
                        Your details
                        </PageTitle>
                    <UserInfoForm
                        handleChange={handleChange}
                        handleKeyup={handleKeyup}
                        handleBlur={handleBlur}
                        values={values}
                        errors={errors}
                    />
                    <AddressWrapper
                        handleChange={handleChange}
                        handleKeyup={handleKeyup}
                        handleBlur={handleBlur}
                        values={values}
                        errors={errors}
                    ></AddressWrapper>
                    {window.collectorsCorner &&
                        <>
                            <PageText>Payment Option</PageText>
                        </>
                    }
                    {window.collectorsCornerTopUp &&
                        <>
                            <PageText>Top up</PageText>
                        </>
                    }
                    <PaymentOptions errors={errors} values={values}></PaymentOptions>

                    {/* Desktop submit */}
                    <Button
                        className="bn bn--primary gtm-linkclick"
                        onClick={() => {
                            handleSubmit();
                        }}
                        type="button"
                        text="Continue"
                    />
                </SideContainer>
                {window.collectorsCorner &&
                    <SideContainer className="pt7">
                        <ContainerBox>
                            <FlexStart>
                                <span className="icon pdf-icon"></span>
                                <div className="pt1">
                                    <p>To create an account offline please download the PDF</p>
                                </div>
                            </FlexStart>
                        </ContainerBox>
                    </SideContainer>
                }

            </div>
        </div>
    );
};

export default UserDetails;
